import React from "react";
import Button from "@/components/button";
import css from "./index.module.scss";
import StripesLeftSvg from "/public/images/misc/stripesLeft.svg";
import StripesRightSvg from "/public/images/misc/stripesRight.svg";

export default function StripedCtaSection({
  headline = "",
  description = "",
  ctaLabel = "Contact Us",
  ctaHref = "/contact",
}) {
  return (
    <section className={`section ${css.stripedCta}`}>
      <div className={css.background}>
        <div className={css.inner}>
          <StripesLeftSvg/>
          <StripesRightSvg/>
        </div>
      </div>
      <div className="sectionInner">
        <h2>{headline}</h2>
        {description && <p>{description}</p>}
        <div className={css.cta}>
          <Button label={ctaLabel} href={ctaHref} ghost/>
        </div>
      </div>
    </section>
  );
}

